import api from './client';

export interface WeatherConditions {
  temp: number;
  feelslike: number;
  humidity: number;
  dew: number;
  windspeed: number;
  windgust: number | null;
  winddir: number;
  conditions: string;
  icon: string;
  uvindex: number;
  pressure: number;
  cloudcover: number;
  precipprob: number;
  precip: number;
  sunrise: string;
  sunset: string;
  moonphase: number;
  visibility: number | null;
  solarradiation: number | null;
  solarenergy: number | null;
  severerisk: number;
  cape: number | null;
  cin: number | null;
}

export interface WeatherHour {
  datetime: string;
  temp: number;
  feelslike: number;
  humidity: number;
  dew: number;
  windspeed: number;
  windgust: number | null;
  winddir: number;
  pressure: number;
  cloudcover: number;
  uvindex: number;
  precipprob: number;
  precip: number;
  preciptype: string[] | null;
  snow: number;
  visibility: number | null;
  conditions: string;
  icon: string;
  solarradiation: number | null;
  solarenergy: number | null;
  severerisk: number;
  cape: number | null;
}

export interface WeatherDay {
  datetime: string;
  tempmax: number;
  tempmin: number;
  temp: number;
  feelslikemax: number;
  feelslikemin: number;
  feelslike: number;
  dew: number;
  humidity: number;
  windspeed: number;
  windspeedmax: number | null;
  windspeedmean: number | null;
  windgust: number | null;
  winddir: number;
  pressure: number;
  cloudcover: number;
  visibility: number | null;
  conditions: string;
  description: string;
  icon: string;
  uvindex: number;
  sunrise: string;
  sunset: string;
  moonphase: number;
  moonrise: string | null;
  moonset: string | null;
  precipprob: number;
  precipcover: number;
  precip: number;
  preciptype: string[] | null;
  snow: number;
  snowdepth: number;
  solarradiation: number | null;
  solarenergy: number | null;
  severerisk: number;
  cape: number | null;
  cin: number | null;
  hours: WeatherHour[];
}

export interface WeatherData {
  currentConditions: WeatherConditions;
  days: WeatherDay[];
  address: string;
  timezone: string;
  description: string;
  fetchedAt: string;
}

export async function fetchWeatherBulk(
  locations: string[],
  signal?: AbortSignal
): Promise<Record<string, WeatherData>> {
  const res = await api.post<Record<string, WeatherData>>('/weather/bulk', { locations }, { signal });
  return res.data;
}

export async function fetchWeather(location: string, signal?: AbortSignal): Promise<WeatherData> {
  const map = await fetchWeatherBulk([location], signal);
  return map[location];
}
